import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

//declarated component
import { AddDatafieldComponent } from './add-datafield.component';

//internal modules
import { AddButtonModule } from 'src/app/views/shared/components/buttons/add-button/add-button.module';
import { DeleteButtonModule } from 'src/app/views/shared/components/buttons/delete-button/delete-button.module';
import { SpinnerModule } from 'src/app/views/shared/components/spinner/spinner.module';
import { FocusDirectiveModule } from 'src/app/directives/focus-directive/focus-directive.module';



@NgModule({
  declarations: [
    AddDatafieldComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,

    //internal modules
    AddButtonModule,
    DeleteButtonModule,
    FocusDirectiveModule,
    SpinnerModule,
  ],
  exports: [
    AddDatafieldComponent
  ]
})
export class AddDatafieldModule { }
